import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useFormContext } from "react-hook-form";
import {
  ANDROID_DEEP_LINK_PLACEHOLDER,
  COPY_VALUES_IN_OTHER_ADS,
  DESTINATION_FALLBACK_CONFIGURATION_TITLE,
  IOS_DEEP_LINK_PLACEHOLDER,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_OPTION } from "../../utils/constants";
import { optionsDestinationFallbackConfiguration } from "../../utils/options";
import ClickableText from "../Texts/ClickableText";
import Select from "../Form/Select";
import TextField from "../Form/TextField";

const DestinationFallbackConfiguration = ({
  basicPath,
  control,
  errors,
  disabled = false,
  hideTitle = false,
  onCopyValuesInOtherAds = () => {},
}) => {
  const { t } = useTranslationApp();
  const { watch } = useFormContext();

  const destinationFallBack = watch(`${basicPath}.destinationFallBack`);
  const showDeepLinkFields =
    destinationFallBack !== ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_OPTION &&
    destinationFallBack !== undefined &&
    destinationFallBack !== null &&
    destinationFallBack !== "";

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {!hideTitle ? (
            <Typography variant="body1">
              {t(DESTINATION_FALLBACK_CONFIGURATION_TITLE)}
            </Typography>
          ) : null}
          <Select
            name={`${basicPath}.destinationFallBack`}
            variant="filled"
            fullWidth
            disabled={disabled}
            doTranslate={true}
            options={optionsDestinationFallbackConfiguration}
            control={control}
            errors={errors}
          />
          <ClickableText
            disabled={disabled}
            onClick={() =>
              onCopyValuesInOtherAds({ type: "destinationFallBack" })
            }
          >
            {t(COPY_VALUES_IN_OTHER_ADS)}
          </ClickableText>
        </Box>
      </Grid>

      {showDeepLinkFields ? (
        <>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="body1">
                {t(ANDROID_DEEP_LINK_PLACEHOLDER)}
              </Typography>
              <TextField
                name={`${basicPath}.appConfiguration.androidDeepLink`}
                variant="filled"
                fullWidth
                disabled={disabled}
                control={control}
                errors={errors}
                rules={{}}
              />
              <ClickableText
                disabled={disabled}
                onClick={() =>
                  onCopyValuesInOtherAds({
                    type: "appConfiguration.androidDeepLink",
                  })
                }
              >
                {t(COPY_VALUES_IN_OTHER_ADS)}
              </ClickableText>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
              }}
            >
              <Typography variant="body1">
                {t(IOS_DEEP_LINK_PLACEHOLDER)}
              </Typography>
              <TextField
                name={`${basicPath}.appConfiguration.iosDeepLink`}
                variant="filled"
                fullWidth
                disabled={disabled}
                control={control}
                errors={errors}
                rules={{}}
              />
              <ClickableText
                disabled={disabled}
                onClick={() =>
                  onCopyValuesInOtherAds({
                    type: "appConfiguration.iosDeepLink",
                  })
                }
              >
                {t(COPY_VALUES_IN_OTHER_ADS)}
              </ClickableText>
            </Box>
          </Grid>
        </>
      ) : null}
    </Grid>
  );
};

export default DestinationFallbackConfiguration;
